export class EfsSnapshotProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recoveryPointArn",
            "baseName": "recoveryPointArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "backupVaultName",
            "baseName": "backupVaultName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceAccountId",
            "baseName": "sourceAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "performanceMode",
            "baseName": "performanceMode",
            "type": "EfsSnapshotPropertiesPerformanceModeEnum",
            "format": ""
        },
        {
            "name": "throughputMode",
            "baseName": "throughputMode",
            "type": "EfsSnapshotPropertiesThroughputModeEnum",
            "format": ""
        },
        {
            "name": "provisionedThroughputMibps",
            "baseName": "provisionedThroughputMibps",
            "type": "number",
            "format": "double"
        }
    ];
    static getAttributeTypeMap() {
        return EfsSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
export var EfsSnapshotPropertiesPerformanceModeEnum;
(function (EfsSnapshotPropertiesPerformanceModeEnum) {
    EfsSnapshotPropertiesPerformanceModeEnum["GeneralPurpose"] = "generalPurpose";
    EfsSnapshotPropertiesPerformanceModeEnum["MaxIo"] = "maxIO";
})(EfsSnapshotPropertiesPerformanceModeEnum || (EfsSnapshotPropertiesPerformanceModeEnum = {}));
export var EfsSnapshotPropertiesThroughputModeEnum;
(function (EfsSnapshotPropertiesThroughputModeEnum) {
    EfsSnapshotPropertiesThroughputModeEnum["Bursting"] = "bursting";
    EfsSnapshotPropertiesThroughputModeEnum["Provisioned"] = "provisioned";
    EfsSnapshotPropertiesThroughputModeEnum["Elastic"] = "elastic";
})(EfsSnapshotPropertiesThroughputModeEnum || (EfsSnapshotPropertiesThroughputModeEnum = {}));
